import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Tags from "../../partials/Tags"
import AuthorAvatar from "../../partials/AuthorAvatar"

function FeaturedPost(featuredPost) {
  const siteSettings = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          slugs {
            blog
          }
        }
      }
    }
  `)
  const { slugs } = siteSettings.site.siteMetadata
  const firstImage = getImage(featuredPost.featureImage)

  return (
    <>
      {/*  Featured article */}
      <div className="pb-12 md:pb-20">
        <article className="max-w-sm mx-auto md:max-w-none grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 xl:gap-16 items-center">
          <Link
            to={`${slugs.blog}/${featuredPost.slug}/`}
            className="relative block group"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <div
              className="absolute inset-0 bg-gray-800 hidden md:block transform md:translate-y-2 md:translate-x-4 xl:translate-y-4 xl:translate-x-8 group-hover:translate-x-0 group-hover:translate-y-0 transition duration-700 ease-out pointer-events-none"
              aria-hidden="true"
            />
            <figure className="relative h-0 pb-9/16 md:pb-3/4 lg:pb-9/16 overflow-hidden transform md:-translate-y-2 xl:-translate-y-4 group-hover:translate-x-0 group-hover:translate-y-0 transition duration-700 ease-out">
              <div>
                {featuredPost.feature_image ? (
                  <GatsbyImage
                    image={firstImage}
                    className="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition duration-700 ease-out"
                    width="540"
                    height="303"
                    alt={featuredPost.title}
                  />
                ) : null}
              </div>
            </figure>
          </Link>
          <div data-aos="fade-left" data-aos-delay="200">
            <header>
              <div className="mb-3">
                <Tags {...{ tags: featuredPost.tags }} />
              </div>
              <h3 className="h3 text-2xl lg:text-3xl mb-2">
                <Link
                  to={`${slugs.blog}/${featuredPost.slug}/`}
                  className="hover:text-gray-100 transition duration-150 ease-in-out"
                >
                  {featuredPost.title}
                </Link>
              </h3>
            </header>
            <p className="text-lg text-gray-400 flex-grow">
              {featuredPost.excerpt}
            </p>
            <footer className="flex items-center mt-4">
              <AuthorAvatar {...{ data: featuredPost }} />
            </footer>
          </div>
        </article>
      </div>
    </>
  )
}

export default FeaturedPost
